import { CompanyFinanceMapper } from "@/adapters/CompanyFinance.mapper";
import { COMPANY_FINANCE_COLUMNS } from "@/types/company/companyFinance.dto";
import { toB2BError, toDataShapeError } from "@/utils/b2bErrors";
import { lazyService } from "@/utils/lazyMock";
import { supabase } from "@/utils/supabase";
const VIEW_NOT_DEPLOYED_CODES = new Set(["PGRST205", "42P01"]);
export class CompanyFinanceService {
    async getFinance(companyId) {
        const { data, error, status } = await supabase()
            .from("v_corp_balances")
            .select(COMPANY_FINANCE_COLUMNS)
            .eq("company_id", companyId)
            .maybeSingle();
        if (error) {
            if (status === 404 || VIEW_NOT_DEPLOYED_CODES.has(error.code ?? "")) {
                return { available: false, source: "supabase", reason: "NOT_DEPLOYED" };
            }
            throw toB2BError(error);
        }
        if (!data) {
            return { available: false, source: "supabase", reason: "NO_ROW" };
        }
        try {
            return { available: true, source: "supabase", finance: CompanyFinanceMapper.rowToDomain(data) };
        }
        catch (parseError) {
            throw toDataShapeError(parseError);
        }
    }
    async updateFinance(companyId, patch) {
        const { error } = await supabase().rpc("corp_company_update", {
            p_company_id: companyId,
            p_patch: CompanyFinanceMapper.toPatch(patch),
        });
        if (error)
            throw toB2BError(error);
    }
}
// Литерал REACT_APP_B2B_MOCK — см. CompanyService.ts / utils/lazyMock.ts (G4).
export const companyFinanceService = process.env.REACT_APP_B2B_MOCK === "true"
    ? lazyService(() => import("@/services/mock/CompanyFinanceServiceMock").then((module) => module.companyFinanceServiceMock))
    : new CompanyFinanceService();
